<template>
  <!-- The partners are Dutch publications, so the row only means something on the Dutch site. -->
  <div
    v-if="isDutchSite"
    class="known-from"
  >
    <span class="known-from__title">
      {{ $t('event_type_example.known_from') }}
    </span>
    <div class="known-from__images">
      <a
        href="https://trouwen.nl/contact/momentshare"
        target="_blank"
        class="known-from__link"
      >
        <NuxtImg
          src="/images/event-types/logo-trouwen-nl.svg"
          width="740"
          height="72"
          loading="lazy"
          alt="trouwen.nl"
          class="known-from__image"
        />
      </a>
      <a
        href="https://bruiloft.nl/contact/momentshare"
        target="_blank"
        class="known-from__link"
      >
        <NuxtImg
          src="/images/event-types/logo-bruiloft-nl.svg"
          width="704"
          height="72"
          loading="lazy"
          alt="bruiloft.nl"
          class="known-from__image"
        />
      </a>
      <a
        href="https://tadaaz.nl/blog/nl/trouw/fotos-gemaakt-gasten-hoe-krijgen/"
        target="_blank"
        class="known-from__link"
      >
        <NuxtImg
          src="/images/event-types/tadaaz.svg"
          width="958"
          height="414"
          loading="lazy"
          alt="tadaaz.nl"
          class="known-from__image known-from__image--taadaz"
        />
      </a>
    </div>
  </div>
</template>

<script setup>
  const { locale } = useI18n()

  const isDutchSite = computed(() => locale.value === 'nl')
</script>

<style lang="scss">
  .known-from {
    display: flex;
    flex-direction: column;
  }

  .known-from__title {
    font-size: 14px;
    font-weight: 700;
  }

  .known-from__link {
    display: flex;
    align-items: center;
  }

  .known-from__images {
    display: flex;
    gap: 20px;
    align-items: center;
    flex-wrap: wrap;
    margin: 16px 0 0;

    @include breakpoint(desktop) {
      gap: 24px;
    }
  }

  .known-from__image {
    height: 12px;
    width: auto;

    @include breakpoint(desktop) {
      height: 14px;
    }
  }

  .known-from__image--taadaz {
    height: 23px;

    @include breakpoint(desktop) {
      height: 28px;
    }
  }
</style>
